import React, { memo } from 'react';
import { EmptySvg } from '@yme/assets/icons';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { SIZE_48 } from '../button/constants';
import { WrapperStyled } from './styled';
/**
 * Floating Action Button:
 * https://www.figma.com/file/1AvCVJdBZRAVYsB5H0vFkC/YME-Design-System?node-id=7852-272474&t=jU4njah0SEWECKJB-0
 */
export const FloatingButton = memo(({ icon = EmptySvg, onClick, size = SIZE_48 }) => (React.createElement(WrapperStyled, { onClick: onClick, size: size },
    React.createElement(SVGIcon, { type: icon, size: ICON_SIZE.s }))));
FloatingButton.displayName = 'FloatingButton_Component';
